import { Transporter } from './transporter.model';

export interface ITransporterConfiguration {
  id?: number;
  key?: string | null;
  value?: string | null;
  transporter?: Transporter;
}

export class TransporterConfiguration implements ITransporterConfiguration {
  constructor(public id?: number, public key?: string | null, public value?: string | null, public transporter?: Transporter) {}
}

export function getTransporterConfigurationIdentifier(transporterConfiguration: ITransporterConfiguration): number | undefined {
  return transporterConfiguration.id;
}
